import {createContext} from 'react'

const BrandsContext = createContext({
  fetchBrands: () => {}
})

export default BrandsContext
